export default __webpack_public_path__ + "static/media/bg2.b94c20f1.png";